import React, { Component } from "react";
import { connect } from "react-redux";

class Pagination extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            itemsPerPage: this.props.itemsPerPage
        }
    }

    firstPage() {
        this.setState({
            currentPage: 1
        }, () => {
            this.getData();
        });
    }

    previousPage() {
        let currentPage = this.state.currentPage;
        if (currentPage > 1) {
            currentPage--;
            this.setState({
                currentPage: currentPage
            }, () => {
                this.getData();
            });
        }
    }

    nextPage() {
        let currentPage = this.state.currentPage;
        if (currentPage < this.props.totalItems) {
            currentPage++;
            this.setState({
                currentPage: currentPage
            }, () => {
                this.getData();
            });
        }
    }

    lastPage() {
        this.setState({
            currentPage: this.props.totalItems
        }, () => {
            this.getData();
        });
    }

    getData() {
        this.props.getDataByChangingPage(this.state.currentPage - 1, this.state.itemsPerPage);
    }


    showResultsPerPage(val) {
        return <option key={val} value={val}>{val}</option>
    }

    changeResultsPerPage(e) {
        let selectedValue = e.target.value;
        this.setState({
            itemsPerPage: selectedValue
        }, () => {
            this.getData();
        });
    }
    render() {
        return (
            <div className="row pagination">
                <div className="col first-page" onClick={() => this.firstPage()}>&lt;&lt;</div>
                <div className="col back-page" onClick={() => this.previousPage()}>&lt;</div>
                <div className="col current-page">
                    {this.state.currentPage}&nbsp;din&nbsp;{this.props.totalItems}
                </div>
                <div className="col next-page" onClick={() => this.nextPage()}>&gt;</div>
                <div className="col last-page" onClick={() => this.lastPage()}>&gt;&gt;</div>
                <div className="results-per-page-container">
                    <select onChange={this.changeResultsPerPage.bind(this)}>
                        {this.props.resultsPerPageList.map(this.showResultsPerPage.bind(this))}
                    </select>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, {})(Pagination);


// WEBPACK FOOTER //
// ./src/SHARED/components/pagination/pagination.component.js